import React from 'react';
import { ThemeProvider } from '../../contexts/ThemeContext';
import { HomeScreen } from '../../pages/HomeScreen';
import { BottomTabBar } from '../ui/BottomTabBar';
import { DeckPhoneFrame } from './DeckPhoneFrame';
interface VexuProductShowcaseProps {
  scale?: number;
}

/**
 * The real Vexu application, in its active state, rendered inside a
 * presentation device shell. Non-interactive — the cover establishes that the
 * product exists rather than demonstrating any workflow.
 */
export function VexuProductShowcase({
  scale = 0.78
}: VexuProductShowcaseProps) {
  return <ThemeProvider initialMode="light" data-id="element-323" data-mp="3lbycfp65t3l8">
      <DeckPhoneFrame scale={scale} data-id="element-324" data-mp="3lczwuk92f2fm">
        <div className="h-full relative pointer-events-none select-none" aria-hidden="true" data-id="element-325" data-mp="3le192s1thuyx">
          <HomeScreen onNavigate={() => undefined} isActivated enabledRules={['busy', 'unanswered']} data-id="element-326" data-mp="2svduzwl8ng7c" />
          <BottomTabBar currentTab="home" onTabChange={() => undefined} data-id="element-327" data-mp="2nw19bf63sf6c" />
        </div>
      </DeckPhoneFrame>
    </ThemeProvider>;
}